import React from 'react';
import { useSelector } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';
import { makeSelectDocumentsCount } from './selectors';

interface Props {
    documentSetId: number; // eslint-disable-line
}

export default function JobAssessmentsTitle(props: Props): React.ReactElement {
    const documentsCount = useSelector((state: AppState) =>
        makeSelectDocumentsCount()(state, props)
    );

    return (
        <Header as="h3">
            Assessments {documentsCount ? `(${documentsCount})` : ''}
        </Header>
    );
}
